/* eslint-disable */
import * as loadApi from './loadApi';
import { initialize as digitalAnalyticsInitialize } from './digitalAnalytics';
let loadAnalytics = ("undefined" === typeof process.env.IGNORE_ANALYTICS) ? true : false;
if (loadAnalytics){
  digitalAnalyticsInitialize();
}
export default loadApi;
